import { View, Utils } from '../vendor/kerneljs';

const MobileNavigation = View.extend({
	isActive:false,

	events: {
		'click .js--navigation-toggle': 'onNavigationToggle'
	},

	initialize: function(){
		this.navigationInner = this.find('.js--navigation-inner');
		this.navigationToggleButton = this.find('.js--navigation-toggle');
		this.eventEmitter.on('menu:open', this.forceClose.bind(this) );
		this.htmlRef = Utils.find('html')[0];
	},

	onNavigationToggle: function() {
		this.isActive = !this.isActive;
		let followFlight = document.getElementsByClassName("follow-flight")[0];
		let siteHeader = document.getElementsByClassName('site-header')[0]
		if ( this.isActive ) {
			this.addClass('is-active');
			Utils.addClass(this.htmlRef,'is-mobilenav-mode');
			Utils.addClass(this.htmlRef,'is-mode');
			
			if(followFlight && siteHeader) {
				followFlight.style.display = 'none';
				siteHeader.style.top = '0px';
			}

			Utils.addClass(this.navigationInner, 'is-active');

			setTimeout(function() {
				this.navigationInner.style.display="none";
				this.navigationInner.style.display="block";
			}.bind(this), 3000);

			this.eventEmitter.emit('siteheader:stick');
		}
		else {
			
			if(followFlight && siteHeader) {
				followFlight.style.display = 'block';
				siteHeader.style.top = followFlight.clientHeight + 'px';
			}

			this.removeClass('is-active');
			Utils.removeClass(this.navigationInner, 'is-active');
			Utils.removeClass(this.htmlRef,'is-mobilenav-mode');

			this.eventEmitter.emit('siteheader:update');
		}
	},

	forceClose: function(instanceId) {
		if ( typeof instanceId === "undefined") {}
		else if ( instanceId === this.instanceId ) return false;

		this.isActive = false;
		this.removeClass('is-active');
		Utils.removeClass(this.htmlRef,'is-mobilenav-mode');
		Utils.removeClass(this.navigationInner, 'is-active');
	}
});

(function(){
	Utils.each(Utils.find('.js--mobile-navigation'), function(elem) {
		new MobileNavigation( {el: elem} );
	});

})();

export default MobileNavigation;